import { useQuery } from '@tanstack/react-query';

import { getActivityLogs, type ListActivityParams } from '../../../api/activity';
import { useAuth } from '../../auth/AuthProvider';

export function useActivityLogs(params: ListActivityParams = {}) {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['activity-logs', params],
    queryFn: () => getActivityLogs(params, tokens!.access_token),
    enabled: Boolean(tokens?.access_token),
  });
}
